import { Photo16, PlanirovkaStroke16, Video16 } from '@cian/ui-kit/icons';
import { IIconProps } from '@cian/ui-kit/icons/internal';
import { UIText1 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './Control.css';
import { EMediaType } from '../../../../types';
import { IInfoControlConfig } from '../../types';

interface IControlProps {
  config: IInfoControlConfig;
  onClick?(): void;
}

const ICONS_MAP: { [key in IInfoControlConfig['type']]: React.ComponentType<IIconProps> } = {
  [EMediaType.Layout]: PlanirovkaStroke16,
  [EMediaType.Photo]: Photo16,
  [EMediaType.Video]: Video16,
};

export const Control: React.FC<IControlProps> = ({ config, onClick }) => {
  const Icon = React.useMemo(() => ICONS_MAP[config.type], [config.type]);

  /* istanbul ignore next */
  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();

      if (onClick) {
        onClick();
      }
    },
    [onClick],
  );

  return (
    <li>
      <button className={styles['button']} onClick={handleClick}>
        <span className={styles['icon']}>
          <Icon display="block" color="white_100" />
        </span>
        <UIText1 fontWeight="bold" color="white_100">
          {config.label}
        </UIText1>
      </button>
    </li>
  );
};
